<div class="invoices-header row mx-0 gy-2">
  <h1 class="col-12 col-sm-auto noselect">Invoices</h1>
  <div class="col-12 col-sm-auto ms-sm-auto d-flex flex-wrap align-items-center gap-2">
    <!-- Filter the board to invoices with work assigned to one mechanic -->
    <select *ngIf="hasEditAll && mechanics.length > 0"
            class="form-select mechanic-filter noselect"
            aria-label="Filter by mechanic"
            [(ngModel)]="mechanicFilter"
            (ngModelChange)="onMechanicFilterChange()">
      <option value="">All Mechanics</option>
      <option *ngFor="let mechanic of mechanics" [value]="mechanic.userId">
        {{ mechanic.firstName }} {{ mechanic.lastName }}
      </option>
    </select>
    <!-- CARFAX feed export: pick a pay date, download that day's file -->
    <div *ngIf="hasViewAll" ngbDropdown autoClose="outside" class="d-inline-block">
      <button type="button" class="btn btn-outline-secondary" ngbDropdownToggle>
        <span class="fa-solid fa-file-export me-1"></span>Carfax Export
      </button>
      <div ngbDropdownMenu class="carfax-export-menu p-3">
        <label for="carfaxExportDate" class="form-label noselect">Invoices paid on</label>
        <input
          id="carfaxExportDate"
          type="date"
          class="form-control mb-2"
          [(ngModel)]="carfaxExportDate" />
        <button
          type="button"
          class="btn btn-primary w-100"
          [disabled]="!carfaxExportDate || exportingCarfax"
          (click)="exportCarfax()">
          <span *ngIf="!exportingCarfax">Download File</span>
          <span *ngIf="exportingCarfax"><span class="spinner-border spinner-border-sm me-1"></span>Generating…</span>
        </button>
      </div>
    </div>
    <button
      *ngIf="hasEditAll"
      class="btn btn-primary btn-create-quote"
      [routerLink]="['/', invoiceRoute, invoiceModuleRoutes.create]">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 5V15M5 10H15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      Create Quote
    </button>
  </div>
</div>

<div *ngIf="loading" class="board-message noselect">Loading invoices...</div>
<div *ngIf="error" class="board-message text-danger noselect">{{ error }}</div>

<div *ngIf="!loading && !error" class="board">
  <section *ngFor="let section of sections" class="status-section">
    <button type="button"
            class="status-header noselect"
            (click)="toggleSection(section.status)"
            [attr.aria-expanded]="isExpanded(section.status)">
      <h2>{{ section.label }}</h2>
      <span class="status-count">{{ grouped[section.status].length }}</span>
      <span class="status-chevron fa-solid"
            [ngClass]="isExpanded(section.status) ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
    </button>

    <div class="invoice-list"
         [class.collapsed]="!isExpanded(section.status)"
         [class.full-width]="section.status === 'IN_PROGRESS'"
         cdkDropList
         [id]="section.status"
         [cdkDropListData]="grouped[section.status]"
         [cdkDropListConnectedTo]="sectionIds"
         [cdkDropListDisabled]="!hasEditAll"
         (cdkDropListDropped)="onInvoiceDropped($event)">

      <div *ngFor="let invoice of grouped[section.status]"
           class="invoice-card"
           cdkDrag
           [cdkDragData]="invoice"
           [cdkDragDisabled]="!hasEditAll">

        <!-- Card header: vehicle + customer + invoice ref; click collapses the card -->
        <div class="invoice-card-header" (click)="toggleInvoice(invoice)">
          <div>
            <div *ngIf="getInvoiceVehicleLabel(invoice)" class="invoice-vehicle-name">
              {{ getInvoiceVehicleLabel(invoice) }}
            </div>
            <div class="invoice-customer">
              <span class="noselect">#{{ invoice.InvoiceNumber }} &middot; </span>{{ getCustomerDisplayName(invoice) }}
            </div>
            <div class="invoice-meta noselect">
              <div>Created: {{ invoice.CreatedAt | date:'MMM d, y' }}</div>
              <div>Last Updated: {{ invoice.UpdatedAt | date:'MMM d, y' }}</div>
            </div>
          </div>
          <div class="invoice-card-header-actions noselect">
            <!-- The only drag surface on the card: everything else scrolls the page. -->
            <span *ngIf="hasEditAll"
                  cdkDragHandle
                  class="drag-handle fa-solid fa-grip-vertical"
                  title="Drag to another status"
                  aria-label="Drag to another status"
                  (click)="$event.stopPropagation()"></span>
            <span class="invoice-chevron fa-solid"
                  [ngClass]="isInvoiceExpanded(invoice) ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
          </div>
        </div>

        <div class="invoice-card-body" [class.collapsed]="!isInvoiceExpanded(invoice)">

        <!-- Vehicles (only when work item rows aren't already carrying them) -->
        <div *ngIf="showVehicleSummary(section, invoice)" class="invoice-vehicles noselect">
          <div *ngFor="let vehicle of invoice.Vehicles" class="invoice-vehicle">
            <span class="fa-solid fa-car me-1"></span>{{ getVehicleDisplayName(vehicle) }}
          </div>
          <div *ngIf="invoice.Vehicles.length === 0" class="text-muted">No vehicles</div>
        </div>

        <!-- Section-specific content -->
        <ng-container [ngSwitch]="section.status">

          <!-- MECHANIC_REVIEW / TODO: work item titles with add/edit -->
          <ng-container *ngSwitchCase="'MECHANIC_REVIEW'">
            <ng-container *ngTemplateOutlet="workItemList; context: { invoice: invoice, section: section }"></ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'TODO'">
            <ng-container *ngTemplateOutlet="workItemList; context: { invoice: invoice, section: section }"></ng-container>
          </ng-container>

          <!-- CUSTOMER_REVIEW: charges to approve or reject line by line -->
          <div *ngSwitchCase="'CUSTOMER_REVIEW'" class="charge-review">
            <div *ngFor="let workItem of allWorkItems[invoice.InvoiceId]"
                 class="charge-row"
                 [class.rejected]="isRejected(workItem)">
              <div class="charge-body">
                <span class="charge-title">{{ workItem.Title }}</span>
                <span class="charge-vehicle noselect">
                  <span class="fa-solid fa-car me-1"></span>{{ workItem.VehicleLabel }}
                </span>
                <span class="charge-vehicle noselect">
                  <span class="fa-solid fa-user-gear me-1"></span>{{ getMechanicLabel(workItem) }}
                </span>
                <span *ngIf="isRejected(workItem) && rejectionReasonFor(workItem)" class="charge-rejection noselect">
                  <span class="fa-solid fa-circle-exclamation me-1"></span>{{ rejectionReasonFor(workItem) }}
                </span>
              </div>
              <span class="charge-values noselect">
                <ng-container *ngIf="workItem.FlatFee == null">
                  <span *ngIf="laborAmount(workItem) > 0">{{ laborAmount(workItem) | currency }} labor</span>
                  <span *ngIf="workItem.PartsPricing != null">{{ workItem.PartsPricing | currency }} parts</span>
                </ng-container>
                <span *ngIf="workItem.FlatFee != null">
                  {{ workItem.FlatFee | currency }} flat fee ({{ workItem.FlatFeeTaxable ? 'taxable' : 'no tax' }})
                </span>
                <span class="charge-line-subtotal">{{ lineSubtotal(workItem) | currency }}</span>
              </span>
              <button *ngIf="canReviewCharges(invoice) && !isRejected(workItem)"
                      type="button"
                      class="btn-icon btn-reject"
                      title="Reject this work item"
                      (click)="rejectWorkItem(workItem)">
                <span class="fa-solid fa-ban"></span>
              </button>
              <button *ngIf="canReviewCharges(invoice) && isPendingRejection(workItem)"
                      type="button"
                      class="btn-icon"
                      title="Undo rejection"
                      (click)="undoRejection(workItem)">
                <span class="fa-solid fa-rotate-left"></span>
              </button>
            </div>
            <div *ngIf="!allWorkItems[invoice.InvoiceId]?.length" class="text-muted noselect">
              No work items yet.
            </div>
            <div class="charge-summary noselect">
              <span *ngIf="invoice.TimeEstimate">Est. time: {{ invoice.TimeEstimate }}</span>
              <span>Sub-Total: {{ invoiceSubtotal(invoice) | currency }}</span>
              <span>Tax: {{ invoiceTax(invoice) | currency }}</span>
              <span class="charge-total">Total: {{ invoiceTotal(invoice) | currency }}</span>
            </div>
          </div>

          <!-- IN_PROGRESS: work item kanban columns -->
          <div *ngSwitchCase="'IN_PROGRESS'" class="work-item-board">
            <div *ngFor="let column of workItemColumns" class="work-item-column">
              <div class="work-item-column-header noselect">{{ column.label }}</div>
              <div class="work-item-column-list"
                   cdkDropList
                   [id]="workItemListId(invoice, column.status)"
                   [cdkDropListData]="workItemGroups[invoice.InvoiceId][column.status]"
                   [cdkDropListConnectedTo]="workItemListIds(invoice)"
                   [cdkDropListDisabled]="!hasEditAll"
                   (cdkDropListDropped)="onWorkItemDropped($event)">
                <div *ngFor="let workItem of workItemGroups[invoice.InvoiceId][column.status]"
                     class="work-item-chip"
                     [class.immovable]="!canMoveWorkItem(workItem)"
                     [title]="workItemMoveTooltip(workItem)"
                     cdkDrag
                     [cdkDragData]="workItem"
                     [cdkDragDisabled]="!canDragWorkItem()">
                  <div class="work-item-chip-title">{{ workItem.Title }}</div>
                  <div class="work-item-chip-detail noselect">
                    <span class="fa-solid fa-car me-1"></span>{{ workItem.VehicleLabel }}
                  </div>
                  <div class="work-item-chip-detail noselect">
                    <span class="fa-solid fa-user-gear me-1"></span>{{ getMechanicLabel(workItem) }}
                  </div>
                  <button *ngIf="hasEditAll"
                          type="button"
                          class="btn-icon btn-edit-work-item"
                          title="Edit work item"
                          (click)="openWorkItemModal(invoice, workItem)">
                    <span class="fa-solid fa-pen"></span>
                  </button>
                  <!-- Mobile: buttons replace drag & drop between lanes -->
                  <!-- commenting out for now, drag functionality seems to work fine -->
                  <!-- <div *ngIf="canMoveWorkItem(workItem)" class="work-item-chip-actions d-sm-none noselect">
                    <button *ngFor="let move of mobileWorkItemMoves[column.status]"
                            type="button"
                            class="btn btn-sm btn-outline-primary"
                            (click)="moveWorkItemTo(workItem, move.target)">
                      {{ move.label }}
                    </button>
                  </div> -->
                </div>
              </div>
            </div>
          </div>

          <!-- AWAITING_PAYMENT / COMPLETE: full breakdown, view-only -->
          <ng-container *ngSwitchDefault>
            <div *ngIf="invoice.TimeEstimate" class="invoice-summary noselect">
              Est. time: {{ invoice.TimeEstimate }}
            </div>
            <ng-container *ngTemplateOutlet="workItemList; context: { invoice: invoice, section: section }"></ng-container>
          </ng-container>
        </ng-container>

        <!-- Add work item on the left, delete opposite it on the right. Delete
             sits here rather than in the card header so it can't be hit while
             reaching for the drag handle, and away from the move-next button
             below so the two aren't confused for one another. -->
        <div *ngIf="hasEditAll || invoice.InvoiceStatus === 'COMPLETE'" class="invoice-card-actions">
          <button *ngIf="hasEditAll && showAddWorkItemButton(section, invoice)"
                  type="button"
                  class="btn btn-sm btn-outline-secondary btn-add-work-item"
                  (click)="openWorkItemModal(invoice)">
            <span class="fa-solid fa-plus me-1"></span>Add Work Item
          </button>
          <button *ngIf="invoice.InvoiceStatus === 'COMPLETE'"
                  type="button"
                  class="btn btn-outline-primary btn-sm btn-view-invoice"
                  title="View invoice PDF"
                  (click)="openInvoicePdf(invoice.InvoiceId)">
            <span class="fa-solid fa-file-pdf me-1"></span>View Invoice
          </button>
          <button *ngIf="hasEditAll"
                  type="button"
                  class="btn btn-outline-danger btn-sm btn-delete-invoice"
                  title="Delete invoice"
                  aria-label="Delete invoice"
                  (click)="deleteInvoice(invoice)">
            <span class="fa-solid fa-trash-can"></span>
          </button>
        </div>

        <!-- Move to next section -->
        <div *ngIf="canMoveNext(section, invoice)" class="invoice-card-footer">
          <button *ngIf="section.status !== 'CUSTOMER_REVIEW'"
                  type="button"
                  class="btn btn-primary btn-sm w-100"
                  (click)="moveNext(section, invoice)">
            {{ section.nextLabel }}
          </button>
          <!-- Customer review: full approval goes to TODO; partial goes back to the shop -->
          <button *ngIf="section.status === 'CUSTOMER_REVIEW'"
                  type="button"
                  class="btn btn-sm w-100"
                  [ngClass]="pendingRejectionCount(invoice) > 0 ? 'btn-warning' : 'btn-primary'"
                  (click)="submitCustomerReview(invoice)">
            {{ customerReviewLabel(invoice) }}
          </button>
        </div>

        </div> <!-- /.invoice-card-body -->
      </div>

      <p *ngIf="grouped[section.status].length === 0" class="empty-section text-muted noselect">
        No invoices in {{ section.label }}.
      </p>
    </div>
  </section>
</div>

<!-- Shared work item list for MECHANIC_REVIEW and TODO cards -->
<ng-template #workItemList let-invoice="invoice" let-section="section">
  <div class="work-items">
    <div *ngFor="let workItem of allWorkItems[invoice.InvoiceId]"
         class="work-item-row"
         [class.rejected]="section.status === 'MECHANIC_REVIEW' && !!workItem.RejectionReason">
      <!-- Row 1: title flexes, edit/view icon hugs the right edge -->
      <div class="work-item-row-header">
        <span class="work-item-row-title">{{ workItem.Title }}</span>
        <button *ngIf="canModifyWorkItems(section)"
                type="button"
                class="btn-icon"
                title="Edit work item"
                (click)="openWorkItemModal(invoice, workItem)">
          <span class="fa-solid fa-pen"></span>
        </button>
        <button *ngIf="showReadOnlyWorkItemButton(section)"
                type="button"
                class="btn-icon"
                title="View work item"
                (click)="openWorkItemModal(invoice, workItem, true)">
          <span class="fa-solid fa-eye"></span>
        </button>
      </div>
      <!-- Row 2: two detail columns -->
      <div class="work-item-row-content">
        <div class="work-item-row-body">
          <span class="work-item-row-detail noselect">
            <span class="fa-solid fa-car me-1"></span>{{ workItem.VehicleLabel }}
          </span>
          <span class="work-item-row-detail noselect">
            <span class="fa-solid fa-user-gear me-1"></span>{{ getMechanicLabel(workItem) }}
          </span>
          <span *ngIf="showWorkItemValues(section) && workItem.ShopHours != null"
                class="work-item-row-detail noselect">
            <span class="fa-solid fa-clock me-1"></span>{{ formatShopTime(workItem.ShopHours) }}
          </span>
          <span *ngIf="section.status === 'MECHANIC_REVIEW' && workItem.RejectionReason"
                class="work-item-rejection noselect">
            <span class="fa-solid fa-circle-exclamation me-1"></span>Rejected: {{ workItem.RejectionReason }}
          </span>
        </div>
        <div *ngIf="showWorkItemValues(section)" class="work-item-row-values noselect">
          <ng-container *ngIf="workItem.FlatFee == null">
            <span *ngIf="workItem.PartsPricing != null">Parts: {{ workItem.PartsPricing | currency }}</span>
            <span *ngIf="laborAmount(workItem) > 0">Labor: {{ laborAmount(workItem) | currency }}</span>
          </ng-container>
          <span *ngIf="workItem.FlatFee != null">
            Flat fee: {{ workItem.FlatFee | currency }} ({{ workItem.FlatFeeTaxable ? 'taxable' : 'no tax' }})
          </span>
          <span class="work-item-row-subtotal">{{ lineSubtotal(workItem) | currency }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="showWorkItemValues(section) && allWorkItems[invoice.InvoiceId]?.length"
         class="work-items-subtotal noselect">
      <span>Sub-Total: {{ invoiceSubtotal(invoice) | currency }}</span>
      <span>Tax: {{ invoiceTax(invoice) | currency }}</span>
      <span class="work-items-total">Total: {{ invoiceTotal(invoice) | currency }}</span>
    </div>

    <!-- Empty state: prominent + to add the first work item -->
    <button *ngIf="!allWorkItems[invoice.InvoiceId]?.length && canModifyWorkItems(section)"
            type="button"
            class="add-first-work-item noselect"
            (click)="openWorkItemModal(invoice)">
      <span class="fa-solid fa-plus"></span>
      <span>Add a work item</span>
    </button>
    <div *ngIf="!allWorkItems[invoice.InvoiceId]?.length && !canModifyWorkItems(section)" class="text-muted noselect">
      No work items yet.
    </div>
  </div>
</ng-template>
